// extracted by mini-css-extract-plugin
export default {"rating":"zI-z","numberOfStars":"AI-z","count":"BI-z","barGraphSpacing":"CI-z","barGraph":"DI-z"};